import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import ProductListWrapper from "../components/ProductListWrapper";
import api, { getCache, setCache } from "../components/api";
import { useFilter } from "../context/FilterContext";

export default function CategoryProducts() {
  const { categoryId, subCategoryId, subHeadingId } = useParams();
  const location = useLocation();
  const [title, setTitle] = useState();
  const [prefix, setPrefix] = useState();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const baseUrl = "/products/category/";

  const { filters } = useFilter();

  const fetchData = useCallback(async () => {
    const createPrefix = (items, urlPrefix = "", id = null) => (
      <div className="nav category-nav">
        {items.map((item) => (
          <li key={item.id} className="nav-item">
            <Link
              to={{
                pathname: `${baseUrl}${urlPrefix}${item.id}`,
                search: location.search, // Retain current filters
              }}
              className={`btn ${item.id.toString() === id ? "active" : ""}`}
            >
              {item.name}
            </Link>
          </li>
        ))}
      </div>
    );

    const createBreadcrumbs = (crumbs) => {
      let url = "/products/category";
      return crumbs.length > 0 ? (
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li key="0" className="breadcrumb-item">
              <Link to={{ pathname: "/products", search: location.search }}>
                All products
              </Link>
            </li>
            {crumbs.map((item, index, array) => {
              url += "/" + item.id;
              return index + 1 === array.length ? (
                <li
                  key={item.id}
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  {item.name}
                </li>
              ) : (
                <li key={item.id} className="breadcrumb-item">
                  <Link to={{ pathname: url, search: location.search }}>
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ol>
        </nav>
      ) : null;
    };

    try {
      let categories = getCache("categories"),
        subCategories = [],
        subHeadings = [],
        currentCategory = {},
        crumbs = [],
        currentSubCategory = {},
        currentSubHeading = {};

      if (!categories) {
        const categoryResponse = await api.get("/categories");
        categories = categoryResponse.data;
        setCache("categories", categories);
      }

      if (categoryId) {
        const subCategoriesKey = "subCategories-" + categoryId;
        subCategories = getCache(subCategoriesKey);
        if (!subCategories) {
          const subCategoryResponse = await api.get("/sub-categories", {
            params: { category: categoryId },
          });
          subCategories = subCategoryResponse.data;
          setCache(subCategoriesKey, subCategories);
        }
        currentCategory = categories.find(
          (item) => item.id.toString() === categoryId
        );
        crumbs.push(currentCategory);
      }

      if (subCategoryId) {
        const subHeadingsKey = "subHeadings-" + subCategoryId;
        subHeadings = getCache(subHeadingsKey);
        if (!subHeadings) {
          const subHeadingResponse = await api.get("/sub-headings", {
            params: { sub_category: subCategoryId },
          });
          subHeadings = subHeadingResponse.data;
          setCache(subHeadingsKey, subHeadings);
        }
        currentSubCategory = subCategories.find(
          (item) => item.id.toString() === subCategoryId
        );
        crumbs.push(currentSubCategory);
      }

      if (subHeadingId) {
        currentSubHeading = subHeadings.find(
          (item) => item.id.toString() === subHeadingId
        );
        setTitle(currentSubHeading?.name || "Subheading");
        setPrefix(
          createPrefix(
            subHeadings,
            `${categoryId}/${subCategoryId}/`,
            subHeadingId
          )
        );
        crumbs.push(currentSubHeading);
      } else if (subCategoryId) {
        setTitle(currentSubCategory?.name || "Subcategory");
        setPrefix(createPrefix(subHeadings, `${categoryId}/${subCategoryId}/`));
      } else if (categoryId) {
        setTitle(currentCategory?.name || "Category");
        setPrefix(createPrefix(subCategories, `${categoryId}/`));
      } else {
        setTitle("All products");
        setPrefix(createPrefix(categories));
      }

      setBreadcrumbs(createBreadcrumbs(crumbs));
    } catch (error) {
      console.error("Failed to fetch category data:", error);
    }
  }, [categoryId, subCategoryId, subHeadingId, location.search]);

  useEffect(() => {
    fetchData();
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [fetchData]);

  return (
    <ProductListWrapper
      title={title}
      prefix={prefix}
      breadcrumbs={breadcrumbs}
      globalFilter={filters}
    />
  );
}
